export default __webpack_public_path__ + "static/dhaval_sarvaiya-ca4800215e001b8c901675529c1837a2.png";